<app-item [entity]="problem" [deleteService]="deleteService" [deleteButtonInMore]="true">
    <app-luna-button *ngIf="!hideButtons" more-buttons iconName="pencil" (clickedEvent)="edit()"></app-luna-button>

    <app-summary [expandable]="true">
        <div title>
            <ng-container *ngIf="titleDisplay === 'title'">
                Problème / Antécédent
            </ng-container>
            <ng-container *ngIf="titleDisplay === 'type'">
                {{problem.type?.label}}
            </ng-container>
        </div>
        <ng-container expandedContent>
            <div class="d-flex gap flex-wrap align-items-center">
                <app-lov-value-summary-field [lovValueSummary]="problem.type" *ngIf="titleDisplay !== 'type'"></app-lov-value-summary-field>
                <app-summary-field [value]="problem.description" *ngIf="problem.description"></app-summary-field>
                <app-summary-field [value]="problem.comment" *ngIf="problem.comment"></app-summary-field>
                <app-summary-field [value]="problem.treatment" *ngIf="problem.treatment"></app-summary-field>
            </div>
            <ng-container *ngIf="problem.locations?.length > 0">
                <div class="d-flex gap flex-wrap align-items-center" *ngFor="let location of problem.locations">
                    <app-lov-value-summary-field *ngIf="location.lovValue" [lovValueSummary]="location.lovValue"></app-lov-value-summary-field>
                    <app-summary-field *ngIf="location.customValue" [value]="location.customValue"></app-summary-field>
                </div>
            </ng-container>
            <ng-container *ngIf="problem.whens?.length > 0">
                <div class="d-flex gap flex-wrap align-items-center" *ngFor="let when of problem.whens">
                    <app-lov-value-summary-field *ngIf="when.lovValue" [lovValueSummary]="when.lovValue"></app-lov-value-summary-field>
                    <app-summary-field *ngIf="when.customValue" [value]="when.customValue"></app-summary-field>
                </div>
            </ng-container>
            <div *ngIf="problem.from || problem.to">
                <app-custom-date-field [from]="problem.from" *ngIf="problem.to"></app-custom-date-field>
            </div>
        </ng-container>
    </app-summary>
</app-item>

